export default __webpack_public_path__ + "sliderImage_1.png";